import { useMutation } from 'react-query';
import { AxiosError } from 'axios';
import api from 'services';
import { ACCOUNT_BLOCKED_API_ERRORS, ApiError } from 'services/api.errors';
import {
  ForgotPasswordConfirmationPayload,
  ForgotPasswordConfirmationResponce,
} from 'services/requests';
import { useNavigate } from 'hooks/routes';
import { protectApiError } from 'utils/typeGuards';

import { MutationKeys } from 'constants/mutationKeys';

export const useConfirmForgotPassword = () => {
  const mutate = async (payload: ForgotPasswordConfirmationPayload) => {
    const { data } = await api.confirmForgotPassword(payload);

    return data;
  };

  const mutationKey = MutationKeys.confirmForgotPassword;
  const { toSetNewPassword, toLoginBlocked } = useNavigate();

  return useMutation<
    ForgotPasswordConfirmationResponce,
    AxiosError<ApiError>,
    ForgotPasswordConfirmationPayload
  >(mutationKey, mutate, {
    onSuccess: (data, variables) => {
      toSetNewPassword({ email: variables.email });
      api.setResetPasswordToken(data.token);
    },
    onError: (error) => {
      if (protectApiError(error) && error.response?.data.code) {
        if (ACCOUNT_BLOCKED_API_ERRORS.includes(error.response?.data.code)) {
          api.logout();
          api.logoutApp();
          toLoginBlocked(error.response?.data);
        }
      }
    },
  });
};
